import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import classNames from "classnames";
import { parseISO } from "date-fns";
import { Identifier, useTranslate } from "react-admin";
import { useHistory } from "react-router-dom";
import resourceNames from "../../../common/data/resourceNames";
import { RecentViolationDto } from "../../../common/data/service-proxies";
import { useTableHeaderStyles } from "../../assets/maintenance-dashboard/common";

interface Props {
  record?: RecentViolationDto;
  id?: Identifier;
  resource?: string;
}

export const DriverViolationsListDetail = ({ record }: Props) => {
  const tableClasses = useTableHeaderStyles();
  const translate = useTranslate();
  const history = useHistory();
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow className={tableClasses.tableHead}>
            <TableCell>Violation</TableCell>
            <TableCell>Start time</TableCell>
            <TableCell>End time</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {record &&
            record.violations?.map((x) => (
              <TableRow
                className={classNames(tableClasses.row, tableClasses.clickable)}
                key={x.violationId}
                onClick={() =>
                  history.push(
                    `/${resourceNames.HOS_DRIVER_LOG_VIEW}/${record.id}/${x.logDate}`
                  )
                }
              >
                <TableCell>
                  <Typography variant="body2">
                    {translate(`appData.violationTypes.${x.type}`)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {parseISO(x.startTime!).toLocaleString("en-US", {
                      timeZone: x.homeTerminalTimeZone!,
                    })}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {x.endTime
                      ? parseISO(x.endTime).toLocaleString("en-US", {
                          timeZone: x.homeTerminalTimeZone!,
                        })
                      : "-"}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
